module.exports = __webpack_public_path__ + "img/3 B_W-min.0bc2e98b.png";